import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[color:var(--dms-cream)]">
      <Navbar />
      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-20 text-center">
        <p className="kicker">Payment cancelled</p>
        <h1 className="font-serif text-4xl text-[color:var(--dms-navy)] mt-3">No worries — your cart is saved.</h1>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        <p className="mt-6 text-[color:var(--dms-navy)]/70">You weren't charged. Go back to the checkout whenever you're ready.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/checkout" className="btn-peach">Return to checkout <ArrowRight className="w-4 h-4" /></Link>
          <Link to="/" className="btn-ghost-navy">Keep shopping</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
